import { Field } from 'Util/Query';
import { OrderQuery as SourceOrderQuery } from 'SourceQuery/Order.query';
/**
 * Order Query
 * @class OrderQuery
 * @namespace Query/Order
 */
export class OrderQuery extends SourceOrderQuery{

    _getDefaultFields() {
        return [
            ...super._getDefaultFields(),
          'ordered_sku'
        ];
    }

    _getPaymentInfoFields() {
        return [
            'method',
            'has_charge',
            'charge_title',
            'charge_value',
            this._getAdditionalInformationField()
        ];
    }
}

export default new OrderQuery();
